// SEO Configuration for all routes
export const seoConfig = {
  home: {
    title: "Map My Pay - Salary Comparison & Career Analytics Platform",
    description:
      "Make informed career decisions with Map My Pay. Compare salaries, analyze compensation packages, explore job opportunities, and access relocation tools. Real-time salary data at your fingertips.",
    keywords:
      "salary comparison, compensation analytics, career planning, job search, salary negotiation, pay transparency, relocation tools",
    structuredData: {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "Map My Pay",
      url: window.location.origin,
      potentialAction: {
        "@type": "SearchAction",
        target: `${window.location.origin}/search?q={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
  },
  dashboard: {
    title: "Dashboard - Map My Pay",
    description:
      "Access your personalized dashboard with salary insights, market trends, and career analytics.",
    keywords:
      "salary dashboard, career analytics, compensation insights, pay data",
  },
  search: {
    title: "Search Jobs & Salaries - Map My Pay",
    description:
      "Search and compare salaries across different roles, locations, and experience levels. Find the best opportunities matching your skills.",
    keywords:
      "job search, salary search, compensation search, find jobs, salary data",
  },
  jobs: {
    title: "Job Opportunities - Map My Pay",
    description:
      "Explore curated job opportunities with transparent salary information. Find your next career move with confidence.",
    keywords:
      "job listings, career opportunities, job openings, employment, hiring",
    structuredData: {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: "Job Opportunities",
      description:
        "Browse job opportunities with transparent salary information",
    },
  },
  comparison: {
    title: "Salary Comparison Tool - Map My Pay",
    description:
      "Compare salaries, benefits, and total compensation packages side-by-side. Make data-driven career decisions.",
    keywords:
      "salary comparison, compensation comparison, pay comparison, benefits analysis",
  },
  community: {
    title: "Community - Map My Pay",
    description:
      "Join the Map My Pay community. Share insights, discuss career topics, and connect with professionals.",
    keywords:
      "career community, professional network, salary discussions, career advice",
  },
  relocation: {
    title: "Relocation Tools - Map My Pay",
    description:
      "Plan your relocation with comprehensive cost of living comparisons, salary adjustments, and city insights.",
    keywords:
      "relocation planning, cost of living, city comparison, moving tools, salary adjustment",
  },
  invest: {
    title: "Investment Insights - Map My Pay",
    description:
      "Explore investment opportunities and financial planning tools to maximize your earnings.",
    keywords:
      "investment planning, financial tools, wealth management, savings",
  },
  profile: {
    title: "Your Profile - Map My Pay",
    description: "Manage your profile, preferences, and career information.",
    keywords: "user profile, account settings, career profile",
  },
  subscription: {
    title: "Subscription Plans - Map My Pay",
    description:
      "Choose the perfect subscription plan for your career needs. Access premium salary data and exclusive features.",
    keywords: "subscription plans, pricing, premium features, membership",
  },
  login: {
    title: "Login - Map My Pay",
    description:
      "Login to access personalized salary insights and career tools.",
    keywords: "login, sign in, access account",
  },
  registration: {
    title: "Sign Up - Map My Pay",
    description:
      "Create your account and start accessing comprehensive salary data and career insights.",
    keywords: "sign up, register, create account, join",
  },
  tour: {
    title: "Product Tour - Map My Pay",
    description:
      "Take a tour of Map My Pay features and discover how to make the most of our platform.",
    keywords: "product tour, features, how to use, tutorial",
  },
  contactUs: {
    title: "Contact Us - Map My Pay",
    description:
      "Get in touch with our team. We're here to help with your questions and feedback.",
    keywords: "contact us, support, help, customer service",
  },
  notification: {
    title: "Notifications - Map My Pay",
    description: "Stay updated with your latest notifications and alerts.",
    keywords: "notifications, alerts, updates",
  },
  fullmap: {
    title: "Full Map - Map My Pay",
    description:
      "Access your personalized dashboard with salary insights, market trends, and career analytics.",
    keywords:
      "salary dashboard, career analytics, compensation insights, pay data",
  },
  salaries: {
    title: "Salaries - Map My Pay",
    description: "Calculate your salary",
    keywords:
      "salary dashboard, salary analytics, compensation insights, salary data",
  },
  RetirementCalculator: {
    title: "Retirement Calculator - Map My Pay",
    description: "Calculate your Retirement Balance",
    keywords:
      "salary dashboard, salary analytics, RetirementCalculator, Retirement, Retirement insights, insights, salary data",
  },
  testimonial: {
    title: "Testimonials - Map My Pay",
    description:
      "Read testimonials from our satisfied users and learn how Map My Pay has helped them in their careers.",
    keywords: "testimonials, reviews, user feedback, success stories",
  },
  lifeInsurance: {
    title: "Life Insurance Calculator - Map My Pay",
    description:
      "Calculate your life insurance needs with our comprehensive life insurance calculator. Get personalized recommendations based on your financial situation.",
    keywords:
      "life insurance calculator, insurance needs, financial planning, life insurance recommendations",
  },
  homeInsurance: {
    title: "Home Insurance Calculator - Map My Pay",
    description:
      "Estimate your home insurance costs with our easy-to-use home insurance calculator. Find the best coverage options for your home.",
    keywords:
      "home insurance calculator, insurance costs, home coverage, insurance options",
  },
  tax: {
    title: "Texas Salary & Tax Calculator - Map My Pay",
    description:
      "Calculate your salary and tax obligations in Texas with our specialized calculator. Get insights into your take-home pay and tax liabilities.",
    keywords:
      "Texas salary calculator, tax calculator, take-home pay, tax obligations",
  },
  referral: {
    title: "Refer a Friend - Map My Pay",
    description:
      "Invite friends to Map My Pay and earn rewards. Share your referral link and help others discover salary insights.",
    keywords:
      "referral, refer a friend, earn rewards, invite, Map My Pay",
  },
  messaging: {
    title: "Messages - Map My Pay",
    description:
      "Connect and chat with professionals in the Map My Pay community.",
    keywords:
      "messaging, chat, professional network, connect, Map My Pay",
  },
  blogDetail: {
    title: "Blog - Map My Pay",
    description:
      "Read in-depth articles on career growth, salary negotiation, financial planning, and compensation insights from Map My Pay.",
    keywords:
      "career article, salary advice, financial planning, compensation insights, Map My Pay blog",
  },
  blogs: {
    title: "Blog - Map My Pay",
    description:
      "Explore career advice, salary tips, financial planning guides, and industry insights on the Map My Pay blog.",
    keywords:
      "career blog, salary tips, financial advice, career insights, compensation guides",
  },
  paycheck: {
    title: "Paycheck Calculator - Map My Pay",
    description:
      "Calculate your exact take-home pay after taxes and deductions. See a full breakdown of federal, state, and local taxes on every paycheck.",
    keywords:
      "paycheck calculator, take-home pay, net pay, payroll calculator, tax withholding",
  },
  mortgage: {
    title: "Mortgage Calculator - Map My Pay",
    description:
      "Calculate your mortgage payments, compare home buying vs renting, and plan your home purchase with our comprehensive mortgage calculator.",
    keywords:
      "mortgage calculator, home loan calculator, monthly payment, home buying, mortgage planning",
  },
  applyJob: {
    title: "Apply for Jobs Across the U.S. | Map My Pay",
    description:
      "Apply for top healthcare and professional jobs across the U.S. with Map My Pay. Submit your application quickly, upload your resume, and connect with trusted employers hiring now.",
    keywords:
      "apply for jobs, healthcare jobs, nurse jobs, travel nurse jobs, job application, upload resume, U.S. jobs, Map My Pay careers",
  },
  jobDetail: {
    title: "Job Details & Apply Online | Map My Pay",
    description:
      "Explore job details including role, pay, location, requirements, and benefits. Apply online in minutes with Map My Pay and connect with trusted employers across the U.S.",
    keywords:
      "job details, apply online, healthcare jobs, nurse jobs, travel nurse jobs, job openings, salary, benefits, Map My Pay",
  },
};

// Organization Structured Data (global)
export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Map My Pay",
  url: window.location.origin,
  logo: `${window.location.origin}/logo512.png`,
  sameAs: [
    // Add social media links here when available
  ],
  contactPoint: {
    "@type": "ContactPoint",
    contactType: "Customer Service",
    availableLanguage: "English",
  },
};

// Breadcrumb helper
export const getBreadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.name,
    item: item.url,
  })),
});
